/*
 * 地图投放画圈选屏相关
 */
let penDrawPoints = []
let mapCursor = null // 地图默认的鼠标指针样式

export default {
  data() {
    return {
      // penDrawPolygon: null,
      // penDrawPolyline: null,
      canDraw: false,
      isMouseDown: false,
      isDraw: false, // 是否正在画
    }
  },
  watch: {
    canDraw(v) {
      if (!mapCursor) mapCursor = window.pMap.getDefaultCursor()
      if (v) {
        // 禁用地图操作
        window.pMap.setStatus({
          zoomEnable: false,
          dragEnable: false,
          doubleClickZoom: false,
          scrollWheel: false
        })
        window.pMap.setDefaultCursor('url("/drawPen.png") 0 32, default')
        document.addEventListener('mouseup', this.handleMouseup)
        window.pMap.on('mousedown', this.onMousedown)
        window.pMap.on('mousemove', this.onDrawMove)
      } else {
        // 启用地图操作
        window.pMap.setStatus({
          zoomEnable: true,
          dragEnable: true,
          doubleClickZoom: true,
          scrollWheel: true
        })
        window.pMap.setDefaultCursor(mapCursor)
        document.removeEventListener('mouseup', this.handleMouseup)
        window.pMap.off('mousedown', this.onMousedown)
        window.pMap.off('mousemove', this.onDrawMove)
      }
    },
    manualDraw(nv) {
      this.$store.commit('setSearchDetail', [])
      if (nv) {
        if (!this.penDrawPolygon) {
          this.penDrawPolygon = new AMap.Polygon({
            strokeColor: '#FF3973',
            strokeWeight: 3,
            fillColor: '#FF3973',
            fillOpacity: 0.1
          })
        }
        this.initDrawline()
        window.pMap.add(this.penDrawPolygon)
        // 若有投放范围，则移除圆形覆盖物
        if (this.circleSearchOverlay) {
          window.pMap.remove(this.circleSearchOverlay)
        }
        this.canDraw = true
      } else {
        window.pMap.remove(this.penDrawPolygon)
        this.penDrawPolygon?.setPath([])
        this.canDraw = false
        penDrawPoints = []
        this.$emit('search')
      }
    }
  },
  methods: {
    handleMouseup() {
      if (this.isMouseDown) {
        this.isMouseDown = false
      }
    },
    onMousedown() {
      this.isMouseDown = true
    },
    initDrawline(){
      if(this.penDrawPolyline) {
        window.pMap.remove(this.penDrawPolyline)
        this.penDrawPolyline.destroy()
      }
      this.penDrawPolyline = new AMap.Polyline({ strokeColor: '#FF3973', strokeOpacity: 1, strokeWeight: 3 })
      window.pMap.add(this.penDrawPolyline)
    },
    // 画圈选点相关方法
    onReDraw() {
      this.$store.commit('setSearchDetail', [])
      this.canDraw = true
      penDrawPoints = []
      this.penDrawPolygon.setPath([])
      this.initDrawline()
    },
    onDrawMove(e) {
      if (this.isMouseDown) { // 按下左键
        this.isDraw = true
        penDrawPoints.push(e.lnglat)
        this.penDrawPolyline?.setPath(penDrawPoints)
      } else if (!this.isMouseDown && this.isDraw) { // 绘制过程中松开左键,立即结束绘制
        window.pMap.remove(this.penDrawPolyline)
        this.penDrawPolyline.destroy()
        this.penDrawPolyline = null
        this.penDrawPolygon?.setPath(penDrawPoints)
        this.isDraw = false
        this.canDraw = false
        this.handlePointsPolygon()
      }
    },
    // 处理小区经纬度是否在多边形内
    async handlePointsPolygon() {
      const round = this.drawedCircleRadius()
      const neSw = this.getNeSw(this.penDrawPolygon?.getBounds())
      if (neSw && round) {
        const penOpt = {
          lon: (neSw.northeast.lng + neSw.southwest.lng) / 2,
          lat: (neSw.northeast.lat + neSw.southwest.lat) / 2,
          round
        }
        const nbhds = await this.nbhdSearchFn(this.curFocus.location, penOpt)
        const filterData = (nbhds || []).filter(nbhd => this.pointInPolygon(new AMap.LngLat(nbhd.lon, nbhd.lat)))
        this.$store.commit('setSearchDetail', filterData)
        // 搜索有数据，但小区经纬度全不在画圈范围内时提示暂无数据
        if (nbhds.length && !filterData.length) {
          this.noneTip()
        }
      }
    },
    // 获取多边形区域外切圆的半径,单位米(m)
    drawedCircleRadius() {
      const neSw = this.getNeSw(this.penDrawPolygon?.getBounds())
      if (neSw) {
        return Math.floor(AMap.GeometryUtil.distance(neSw.northeast, neSw.southwest) / 2)
      }
      return 0
    },
    // 获取多边形 东北角、西南角 坐标对象
    getNeSw(bound) {
      if (bound) {
        return { northeast: bound.getNorthEast(), southwest: bound.getSouthWest() }
      }
    },
    /**
     * 判断小区坐标点是否在画圈区域内
     * @param point 小区经纬度坐标
     */
    pointInPolygon(point) {
      // const polygonPath = this.penDrawPolygon?.getPath()
      // if (polygonPath) {
      //   return AMap.GeometryUtil.isPointInPolygon(point, polygonPath)
      // }
      return this.penDrawPolygon?.contains(point)
    }
  }
}
